var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBills = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  "data-name": "Group 223310"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Fill 3",
  d: "M42.022 17.552c-1.129 0-2.624-.025-4.485-.025a8.341 8.341 0 0 1-8.273-8.34V1.148A1.139 1.139 0 0 0 28.133 0H14.909A11.223 11.223 0 0 0 3.75 11.272V38.21A11.731 11.731 0 0 0 15.424 50h19.692A11.189 11.189 0 0 0 46.25 38.755V18.677a1.132 1.132 0 0 0-1.131-1.145c-1.057.007-2.324.02-3.1.02",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Fill 1",
  d: "M35.21 1.419a1.193 1.193 0 0 0-2.053.831v6.6a5.066 5.066 0 0 0 5.043 5.04c1.742.02 4.162.025 6.218.02a1.192 1.192 0 0 0 .858-2.02C42.637 9.144 37.915 4.229 35.21 1.419",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Combined Shape",
  d: "M17.436 35.956a1.862 1.862 0 0 1 0-3.724h13.61a1.862 1.862 0 0 1 0 3.724Zm0-12.487a1.861 1.861 0 1 1 0-3.722h8.462a1.861 1.861 0 1 1 0 3.721Z"
}))));
export default SvgBills;